import History, { IHistoryState } from '@store/modules/ui/user/history/historyIndex';
import Account, { IAccountState } from '@store/modules/ui/user/account/accountIndex';
import Notifications, { INotificationsState } from '@store/modules/ui/user/notifications/notificationsIndex';
import Messages from '@store/modules/ui/user/messages/messagesIndex';
import Preferences, {
    IPreferencesState,
    PreferencesGetters,
} from '@store/modules/ui/user/preferences/preferencesIndex';

export interface IUserState {
    histories: IHistoryState;
    account: IAccountState;
    notifications: INotificationsState;
    preferences: IPreferencesState;
}

export interface UIUserGetters {
    preferences: PreferencesGetters;
}

export default {
    namespaced: true,
    modules: {
        history: History,
        account: Account,
        notifications: Notifications,
        messages: Messages,
        preferences: Preferences,
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/user/userIndex.ts